module.exports = __webpack_public_path__ + "img/metadata_active.b501e58b.svg";